import { makeStyles } from "@material-ui/core/styles";

const FONT_FAMILY = "'IBM Plex Sans', 'Roboto', 'Segoe UI', sans-serif";
const STAY_BLUE = "#268ED6";
const STAY_BLUE_HOVER = "#175580";
const EXIT_RED = "#B80000";
const EXIT_RED_HOVER = "#510000";

const useDialogStyle = makeStyles({
  paper: {
    width: "388px",
    maxWidth: "388px",
    padding: "24px",
    borderRadius: "12px",
    fontFamily: FONT_FAMILY,
  },
  title: {
    padding: 0,
    fontFamily: FONT_FAMILY,
    fontSize: "1.25rem",
    fontWeight: 500,
    lineHeight: 1.6,
    letterSpacing: 0,
    color: "rgba(0, 0, 0, 0.87)",
  },
  content: {
    padding: "16px 0 0",
  },
  body: {
    margin: 0,
    fontFamily: FONT_FAMILY,
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: 1.57,
    letterSpacing: 0,
    color: "rgba(0, 0, 0, 0.6)",
  },
  actions: {
    padding: 0,
    paddingTop: "24px",
    display: "flex",
    gap: "12px",
  },
  button: {
    flex: 1,
    margin: 0,
    color: "white",
    fontFamily: FONT_FAMILY,
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: 1.75,
    letterSpacing: 0,
    borderRadius: "9999px",
    textTransform: "none",
  },
  stayButton: {
    "&": { backgroundColor: STAY_BLUE },
    "&:hover": { backgroundColor: STAY_BLUE_HOVER },
  },
  exitButton: {
    "&": { backgroundColor: EXIT_RED },
    "&:hover": { backgroundColor: EXIT_RED_HOVER },
  },
});

export default useDialogStyle;
